module.exports = __webpack_public_path__ + "img/admin_avatar.b5fec00c.jpg";